import uploadImage from "@faire/web-api--source/endpoints/www/api/image/upload/post";

/**
 * Cannot use web-api for this endpoint as it is a multi-part form
 */
export const uploadImageFile = (
  image: Blob,
  onUploadProgress?: (progressEvent: uploadImageFile.IProgressEvent) => void,
  formData?: FormData
) => {
  const data = formData ?? new FormData();
  data.append("file", image);
  return uploadImage(data, { onUploadProgress });
};

export namespace uploadImageFile {
  export interface IProgressEvent {
    loaded: number;
    total?: number;
    lengthComputable: boolean;
  }
}
